module.exports = __webpack_public_path__ + "assets/img/EKS-smiley-sad.7dc08f6d.svg";